import { useState, useEffect } from 'react';

var useHandleInputCursor = function (inputRef, value, defaultCursorBehavior, isSerialNumber) {
    if (defaultCursorBehavior === void 0) { defaultCursorBehavior = false; }
    if (isSerialNumber === void 0) { isSerialNumber = false; }
    var _a = useState(0), cursorPosition = _a[0], setCursorPosition = _a[1];
    useEffect(function () {
        if (inputRef.current && !defaultCursorBehavior) {
            var element = inputRef.current;
            if (element.type === 'email') {
                // no support for setSelectionRange on email input
                return;
            }
            var hadFocusBefore = document.activeElement === element;
            element.setSelectionRange(cursorPosition, cursorPosition); // Set cursor position
            // when using setSelectionRange on iOS the element get focus when calling setSelectionRange
            if (!hadFocusBefore) {
                element.blur();
            }
        }
    }, [value]);
    var checkCursorForSerialNumber = function (currentLength, preFormatLength, currentCursorPosition) {
        return isSerialNumber && currentLength !== preFormatLength && currentCursorPosition === 5;
    };
    var updateCursorPosition = function (currentValue, onChangeEvent) {
        var _a = onChangeEvent.currentTarget, eventValue = _a.value, selectionStart = _a.selectionStart;
        var currentCursorPosition = selectionStart !== null && selectionStart !== void 0 ? selectionStart : currentValue.length;
        var preFormatLength = eventValue.length;
        var currentLength = currentValue.length;
        /* The space will always be added after the 4th character for serialNumber
         Need to move the cursor a step forward or back depending on if typing or deleting
         if the cursor is at the postion of the space
        */
        if (checkCursorForSerialNumber(currentLength, preFormatLength, currentCursorPosition)) {
            var diff = currentLength - preFormatLength;
            setCursorPosition(currentCursorPosition + diff);
        }
        else {
            setCursorPosition(currentCursorPosition);
        }
    };
    return { cursorPosition: cursorPosition, setCursorPosition: setCursorPosition, updateCursorPosition: updateCursorPosition };
};

export { useHandleInputCursor as default };
